( function( root, factory ) {
	'use strict';

	if ( typeof define === 'function' && define.amd && define.amd.dust === true ) {
		define( 'dust_extra',[ 'dust.core' ], factory );
	}
	else if ( typeof exports === 'object' ) {
		module.exports = factory( require( 'dustjs-linkedin' ) );
	}
	else {
		factory( root.dust );
	}
}( this, function( dust ) {
	'use strict';

	function log( helper, msg, level ) {
		level = level || 'INFO';
		helper = helper ? '{@' + helper + '}: ' : '';

		dust.log( helper + msg, level );
	}

	var helpers = {

		/**
		 * uppercase first letter of word
		 * @param chunk
		 * @param context
		 * @param bodies
		 * @param params
		 */

		'ucfirst': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				chunk.write( data.charAt( 0 ).toUpperCase( ) + data.slice( 1 ) );

				return chunk.end( );
			} );
		},

		/**
		 * convert string to lowercase
 		 * @param chunk
 		 * @param context
 		 * @param bodies
 		 * @param params
		 */

		'strtolower': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				chunk.write( data.toLowerCase( ) );

				return chunk.end( );
			} );
		},

		/**
		 * replaces substring in body with another string
 		 * @param chunk
 		 * @param context
 		 * @param bodies
 		 * @param params
		 */

		'replace': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				var search = context.resolve( params.search ),
					replace = context.resolve( params.replace );

				//Clean the input search for special characters
				search = search.replace( /([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1" );

				chunk.write( data.replace( new RegExp( search, 'g' ), replace ) );

				return chunk.end( );
			} );
		},

		/**
		 * Given a substring, replace variables with the given text
 		 * @param chunk
 		 * @param context
 		 * @param bodies
 		 * @param params
		 */

		'variables': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				var source = context.resolve( params.source ),
					bold = context.resolve( params.bold ),
					str = data || '',
					escape, i;

				escape = function( aString ) {
					// From dust core
					// https://github.com/linkedin/dustjs/blob/v2.7.2/lib/dust.js#L1076
					var HCHARS = /[&<>"']/,
						AMP = /&/g,
						LT = /</g,
						GT = />/g,
						QUOT = /\"/g,
						SQUOT = /\'/g;

					if ( HCHARS.test( aString ) === false ) {
						return aString;
					}
					else {
						return aString.replace( AMP, '&amp;' ).replace( LT, '&lt;' ).replace( GT, '&gt;' ).replace( QUOT, '&quot;' ).replace( SQUOT, '&#39;' );
					}
				};

				for ( i in source ) {
					if ( source.hasOwnProperty( i ) === true ) {
						if ( bold === 'true' ) {
							str = str.replace( new RegExp( '{' + i + '}', 'g' ), '<b>' + escape( source[ i ] ) + '</b>' );
						}
						else {
							str = str.replace( new RegExp( '{' + i + '}', 'g' ), escape( source[ i ] ) );
						}
					}
				}

				chunk.write( str );

				return chunk.end( );
			} );
		},

		/**
		 * formats a number like a currency
		 * @param chunk
		 * @param context
		 * @param bodies
		 * @param params
		 */

		'currency': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				chunk.write( '$' + parseFloat( data ).toFixed( 2 ) );

				return chunk.end( );
			} );
		},

		/**
		 * https://github.com/rragan/dust-motes/blob/master/src/helpers/control/iterate/iterate.js
		 * iterate helper, loops over given object.
		 * Inspired: https://github.com/akdubya/dustjs/issues/9
		 *
		 * Example:
		 * {@iterate key=obj}{$key}-{$value} of type {$type} with parent key: {$parentKey}{~n}{/iterate}
		 *
		 * @param key - object of the iteration - Mandatory parameter
		 * @param sort - Optional. If omitted, no sort is done. Values allowed:
		 * sort="asc" - sort ascending (per JavaScript array sort rules)
		 * sort="desc" - sort descending
		 * sort="fname" - Look for fname object in global context,
		 * if found, treat it as a JavaScript array sort compare function.
		 * if not found, result is undefined (actually sorts ascending
		 * but you should not depend on it)
		 */

		'iterate': function( chunk, context, bodies, params ) {
			var body = bodies.block,
				sort, arr, i, k, obj,
				compareFn;

			params = params || { };

			function desc( a, b ) {
				if ( a < b ) {
					return 1;
				}
				else if ( a > b ) {
					return -1;
				}

				return 0;
			}

			function processBody( key, value ) {
				return body( chunk, context.push( {
					$key: key,
					$value: value,
					$type: typeof value
				} ) );
			}

			if ( params.key ) {
				obj = context.resolve( params.key );

				if ( body ) {
					if ( !!params.sort ) {
						sort = context.resolve( params.sort );
						arr = [ ];

						for ( k in obj ) {
							if ( obj.hasOwnProperty( k ) ) {
								arr.push( k );
							}
						}

						compareFn = context.global[ sort ];

						if ( !compareFn && sort === 'desc' ) {
							compareFn = desc;
						}

						if ( compareFn ) {
							arr.sort( compareFn );
						}
						else {
							arr.sort( );
						}

						for ( i = 0; i < arr.length; i++ ) {
							chunk = processBody( arr[ i ], obj[ arr[ i ] ] );
						}
					}
					else {
						for ( k in obj ) {
							if ( obj.hasOwnProperty( k ) ) {
								chunk = processBody( k, obj[ k ] );
							}
						}
					}
				}
				else {
					log( 'iterate', 'Missing body block in the iter helper.', 'WARN' );
				}
			}
			else {
				log( 'iterate', 'Missing parameter \'key\' in the iter helper.', 'WARN' );
			}

			return chunk;
		},

		/**
		 * Adds multiple conditional OR support; does not support null values
		 * Usage example (2 conditions shown here):
		 * {@or key1=check_user_id value1=user_id key2=check_person_id value2=person_id}
		 * Do not enclose keys or values in "" or {}
		 * @param chunk
		 * @param context
		 * @param bodies
		 * @param params
		 */

		'or': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				var check_params = context.resolve( params ),
					k, value_name;

				for ( k in check_params ) {
					if ( check_params.hasOwnProperty( k ) === true ) {
						if ( k.indexOf( 'key' ) === 0 ) {
							value_name = 'value' + k.slice( 3 );

							if ( check_params.hasOwnProperty( value_name ) === true ) {
								// Does it match? (abstract comparison)
								if ( check_params[ value_name ] == check_params[ k ] && check_params[ k ] !== null ) {
									chunk.write( data );
								}
							}
						}
					}
				}

				return chunk.end( );
			} );
		},

		/**
		 * encodes a string with encodeURIComponent
		 * @param chunk
		 * @param context
		 * @param bodies
		 * @param params
		 */
		'encodeuricomponent': function( chunk, context, bodies, params ) {
			return chunk.capture( bodies.block, context, function( data, chunk ) {
				chunk.write( encodeURIComponent( data ) );

				return chunk.end( );
			} );
		}
	};

	for ( var key in helpers ) {
		if ( helpers.hasOwnProperty( key ) === true ) {
			dust.helpers[ key ] = helpers[ key ];
		}
	}

	return dust;
} ) );

